import { render, staticRenderFns } from "./DialogTopic.vue?vue&type=template&id=298fa0a5&scoped=true"
import script from "./DialogTopic.vue?vue&type=script&lang=js"
export * from "./DialogTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298fa0a5",
  null
  
)

export default component.exports